/**
 * Which pages count as a PUBLIC page view on the Analytics page.
 *
 * The tracker recorded every page that was not under /manage, so a club's
 * "public visits" were mostly its own staff and families signing in: on
 * dev-tenant 3,380 of 4,849 recorded views were the sign-in page, 436 the
 * kiosk and 139 pages inside the member portal (measured 2026-10-08).
 *
 * A page is not public when the first part of its path after the club is one
 * of these. Keep this list identical to NON_PUBLIC_SEGMENTS in the backend's
 * src/utils/analyticsPaths.js, which refuses and hides the same pages.
 */
export const NON_PUBLIC_SEGMENTS = [
  // staff
  "manage",
  "admin",
  "dashboard",
  "profile",
  "kiosk",
  // signed-in families and athletes
  "member",
  "athlete",
  // signing in and account links
  "login",
  "forgot-password",
  "reset-password",
  "magic-login",
  "accept-invite",
  "sign-waiver",
];

const NON_PUBLIC = new Set(NON_PUBLIC_SEGMENTS);

/** False for sign-in, kiosk, member and staff pages, e.g. "/my-club/member/view-billing". */
export function isPublicPagePath(pagePath: string | null | undefined): boolean {
  if (typeof pagePath !== "string") return true;
  const pathOnly = pagePath.split(/[?#]/)[0];
  const segment = (pathOnly.split("/")[2] || "").toLowerCase();
  return !NON_PUBLIC.has(segment);
}
